// extracted by mini-css-extract-plugin
module.exports = {"container":"ArticleCondensed_container__6ABjX","link":"ArticleCondensed_link__CpPN7","title":"ArticleCondensed_title__XE5FE"};